/* import __COLOCATED_TEMPLATE__ from './manage-ticket-types-item.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {};
}

const ManageTicketTypesItem = templateOnlyComponent<Signature>();
export default ManageTicketTypesItem;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::LeftNav::ManageTicketTypesItem': typeof ManageTicketTypesItem;
    'inbox2/left-nav/manage-ticket-types-item': typeof ManageTicketTypesItem;
  }
}
